module.exports = __webpack_public_path__ + "img/boton1.1dcdfae9.png";